import type { IconData } from '@stacksjs/iconify-core'

export const travelShip: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.5 0L0 8.5h8.5zM-.001 10A8.336 8.336 0 0 0 16 10zM16 8.5l-6-6v6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelShip
